import { gql } from '@apollo/client'

export const GET_EPISODES = gql`
  query GetEpisodes (
    $titleGroupIds: [String]!,
    $language: [String]!,
    $imageLanguages: [String]!,
    $seasonNumber: [Int]!,
    $imageType: [String] = ["d6-keyart-no-text"]
  ) {
    contentList(
        where: {
            titleGroupId: { in: $titleGroupIds }
        }
        language: $language
    ) {
        content {
            id
            contentEpisodes(seasonNumber: $seasonNumber, language: $language, content: [{ publishedState: PUBLISHED_NOW }]) {
                contentAnalytic {
                    votesUpCountTotal
                    votesCountTotal
                }
                id
                title
                path
                episodeNumber
                seasonNumber
                displayType
                studio
                contentType
                subType
                contentId
                titleGroupId
                seasonsCount
                episodesCount (content: [{ publishedState: PUBLISHED_NOW }])
                isNew
                primaryLanguage
                languageFullText
                cast
                instructor
                published
                shortDescription
                references (typesByTypeTag: true) {
                    id
                    contentReferenceType {
                        type
                    }
                    contentTo (language: $language) {
                        title
                        contentType
                        contentId
                        language
                        path
                    }
                }
                featureMedia {
                    duration
                    mediaId
                    mediaAssets {
                        language
                        mediaReferenceType
                    }
                    contentPolicy {
                        shareAllowed
                        accessCheck {
                            allowed
                            countryAllowed
                            subscriptionsAllowed
                            isFreeAllowed
                        }
                        optionIds
                    }
                    userMediaPosition {
                        position
                    }
                }
                previewMedia {
                    mediaId
                }
                imageContentRelationships (
                    language: $imageLanguages
                    types: $imageType
                ) {
                    type
                    image {
                        url
                    }
                }
                contentSeries(language: $language) {
                    id
                    contentId
                    title
                    path
                }
                contentFeatured (language: $language, content: [{ publishedState: PUBLISHED_NOW }]) {
                    content {
                        contentAnalytic {
                            votesUpCountTotal
                            votesCountTotal
                        }
                        id
                        title
                        path
                        ctaProductUrl
                        episodeNumber
                        seasonNumber
                        displayType
                        contentType
                        subType
                        contentId
                        isNew
                        primaryLanguage
                        languageFullText
                        shortDescription
                        cast
                        instructor
                        references (typesByTypeTag: true) {
                            id
                            contentReferenceType {
                                type
                            }
                            contentTo (language: $language) {
                                title
                                contentType
                                contentId
                                language
                                path
                            }
                        }
                        featureMedia {
                            duration
                            mediaId
                            mediaAssets {
                                language
                                mediaReferenceType
                            }
                            contentPolicy {
                                shareAllowed
                                accessCheck {
                                    allowed
                                    countryAllowed
                                    subscriptionsAllowed
                                    isFreeAllowed
                                }
                                optionIds
                            }
                            userMediaPosition {
                                position
                            }
                        }
                        previewMedia {
                            mediaId
                        }
                    }
                    featuredType
                }
            }
            allContentEpisodes: contentEpisodes(language: $language, content: [{ publishedState: PUBLISHED_NOW }]) {
                seasonNumber
            }
        }
    }
}
`

export const GET_COURSE_MODULES = gql`
    query GetCourseModules (
        $titleGroupId: String!,
        $language: [String]!,
        $primaryLanguage: [String]!,
        $imageType: [String]!
        ) {
        contentList(
            where: { titleGroupId: { eq: $titleGroupId } }
            language: $language
        ) {
            content {
                contentId
                contentType
                language
                id
                courseProgress {
                    state
                    completionCount
                    metrics {
                        totalModules
                        completedModules
                        totalItems
                        completedItems
                        percentageModulesComplete
                        percentageItemsComplete
                    }
                }
                contentReferencesTo(types: ["course-module"], order: [["sortKey", "ASC"]]) {
                    id
                    sortKey
                    contentFrom(language: $language) {
                        id
                        contentId
                        contentType
                        language
                        languageFullText
                        titleGroupId
                        titleId
                        primaryLanguage
                        contentPolicyPolicyId
                        title
                        shortDescription
                        description (format: HTML)
                        path
                        dayNumber
                        published
                        publishedAtDate
                        contentAssetReferences (contentAssetReferences: {type: "worksheet"}) {
                            asset {
                                originalFileName
                                language
                                renderUrl
                                mimeType
                                uuid
                                courseItemProgress(courseTitleGroupId: $titleGroupId) {
                                    itemId
                                    itemType
                                    state
                                }
                            }
                            contentAssetReferenceType {
                                type
                            }
                        }
                        courseModuleProgress(courseTitleGroupId: $titleGroupId) {
                            state
                            metrics {
                                totalItems
                                completedItems
                            }
                        }
                        contentReferencesTo(types: ["course-module-practice", "course-module-other"], order: [["sortKey", "ASC"]]) {
                            id
                            label
                            sortKey
                            contentReferenceType {
                                type
                            }
                            contentFrom(language: $language, content: [{ publishedState: PUBLISHED_NOW }]) {
                                contentAnalytic {
                                    votesUpCountTotal
                                    votesCountTotal
                                }
                                id
                                title
                                path
                                episodeNumber
                                seasonNumber
                                displayType
                                studio
                                contentType
                                subType
                                contentId
                                titleGroupId
                                seasonsCount (language: $primaryLanguage)
                                episodesCount (language: $primaryLanguage, content: [{ publishedState: PUBLISHED_NOW }])
                                isNew
                                primaryLanguage
                                languageFullText
                                cast
                                instructor
                                published
                                createdAt
                                shortDescription
                                description (format: HTML)
                                ctaLabel
                                ctaPath
                                courseItemProgress(courseTitleGroupId: $titleGroupId) {
                                    state
                                }
                                contentAssetReferences (contentAssetReferences: {type: "worksheet"}) {
                                    asset {
                                        originalFileName
                                        language
                                        renderUrl
                                        mimeType
                                        uuid
                                        courseItemProgress(courseTitleGroupId: $titleGroupId) {
                                            itemId
                                            itemType
                                            state
                                        }
                                    }
                                    contentAssetReferenceType {
                                        type
                                    }
                                }
                                references (typesByTypeTag: true) {
                                    id
                                    contentReferenceType {
                                        type
                                    }
                                    contentTo (language: $language) {
                                        title
                                        contentType
                                        contentId
                                        language
                                        path
                                    }
                                }
                                featureMedia {
                                    duration
                                    mediaId
                                    mediaAssets {
                                        language
                                        mediaReferenceType
                                    }
                                    contentPolicy {
                                        shareAllowed
                                        accessCheck {
                                            allowed
                                            countryAllowed
                                            subscriptionsAllowed
                                            isFreeAllowed
                                        }
                                        optionIds
                                    }
                                    userMediaPosition {
                                        position
                                    }
                                }
                                previewMedia {
                                    mediaId
                                }
                                imageContentRelationships (
                                    language: $language
                                    types: $imageType
                                ) {
                                    type
                                    image {
                                        url
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`

export const COURSE_START = gql`
    mutation CourseStart ($titleGroupId: String!) {
        courseStart(courseTitleGroupId: $titleGroupId) {
            state
            completionCount
        }
    }
`

export const COURSE_RESET = gql`
    mutation CourseReset ($titleGroupId: String!) {
        courseReset(courseTitleGroupId: $titleGroupId) {
            state
            completionCount
        }
    }
`

export const COURSE_MODULE_MARK_COMPLETE = gql`
    mutation CourseModuleMarkComplete ($titleGroupId: String!, $moduleTitleGroupId: String!) {
        courseModuleMarkComplete(
            courseTitleGroupId: $titleGroupId
            courseModuleTitleGroupId: $moduleTitleGroupId
        ) {
            state
        }
    }
`

export const USER_STATE_CREATE_OR_UPDATE = gql`
    mutation UserStateCreateOrUpdate (
        $progressItemType: UserStateProgressItemType! = VIDEO
        $progressItemId: String!
        $parentContentTitleGroupId: String!
        $state: UserStateState!
    ) {
        userStateCreateOrUpdate(
            input: {
                progressItemType: $progressItemType
                progressItemId: $progressItemId
                parentContentTitleGroupId: $parentContentTitleGroupId
                state: $state
            }
        ) {
            state
        }
    }
`
